import React from 'react'
import AxisLabel from './axis-label'
import EasingTick from './shapes/easing-tick'
import EasingVerticalTick from './shapes/easing-vertical-tick'
import { labelDimensions } from './layouts/gutters'

import { CHART_DEBUG, AXIS_DIAGONAL, PADDING } from './constants'

class XAxis extends React.PureComponent {
  static defaultProps = {
    offset: 0,
    label: '',
    format: n => n,
    ticks: [],
    height: 0,
    x: 0,
    y: 0,
    className: ''
  }

  renderTick(tick, index) {
    const { scale, format, offset, className } = this.props

    return (
      <EasingTick
        key={index}
        className={className}
        x={scale(tick) + offset}
        y={PADDING * 1.5}
        label={format(tick)}
      />
    )
  }

  renderVerticalTick(tick, index) {
    const { scale, format, offset, className } = this.props

    return (
      <EasingVerticalTick
        key={index}
        className={className}
        x={scale(tick) + offset}
        y={PADDING}
        label={format(tick)}
        rotation={AXIS_DIAGONAL}
      />
    )
  }

  renderDebug(label) {
    const { scale } = this.props
    const [left, right] = scale.range()

    return (
      <g fill="none" strokeDasharray="2 1">
        {/* padding-outer */}
        <rect x={left} width={right - left} height={PADDING} stroke="orange" />
      </g>
    )
  }

  renderLabel(label) {
    const { scale, height } = this.props
    const [left, right] = scale.range()

    return (
      <AxisLabel x={left} height={height} width={right - left} label={label} />
    )
  }

  render() {
    const { className, ticks, vertical, scale, label, x, y } = this.props
    const [left, right] = scale.range()

    const lines = labelDimensions(label.toUpperCase(), right - left)

    return (
      <g className={`axis -x ${className}`} transform={`translate(${x},${y})`}>
        {CHART_DEBUG ? this.renderDebug(lines) : null}

        {ticks.map(vertical ? this.renderVerticalTick : this.renderTick, this)}

        {this.renderLabel(lines)}
      </g>
    )
  }
}

export default XAxis



// WEBPACK FOOTER //
// /home/runner/work/web-interactive/web-interactive/lib/components/charts/x-axis.js